import { useState } from 'react';
import CarrierPricingPeriodsForm from 'components/forms/CarrierFormFactory/CarrierPricingPeriodsForm';
import { PageLoader } from 'remote/global';
import { useOperatorsPricingSeasonalAdjustmentsQuery } from 'api/queries/operators';
import { PaginationQueryParams } from 'api/types';

function PricingPeriodsView() {
  const [queryParams, setQueryParams] = useState<PaginationQueryParams>({
    pageNo: '0',
  });
  const {
    data: pricingSeasonalAdjustments,
    isLoading,
    isSuccess,
  } = useOperatorsPricingSeasonalAdjustmentsQuery(queryParams);

  if (isLoading) return <PageLoader />;
  if (!isSuccess) return null;

  return (
    <CarrierPricingPeriodsForm
      handlePageChange={(num) => {
        setQueryParams((p) => ({ ...p, pageNo: String(num) }));
      }}
      defaultValues={{ rows: pricingSeasonalAdjustments.elements }}
    />
  );
}

export default PricingPeriodsView;
